import { useState, Fragment } from "react";
import { Menu, MenuButton, Transition, MenuItems, MenuItem } from "@headlessui/react";
import { Cog8ToothIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { AlertLevel } from "../../components/AlertMessage";
import { CoursePromptReviewGroup } from "./coursePromptReviewGroups/coursePromptReviewGroupsApiSlice";
import { RemovePeerReviewGroupButton, RemovePeerReviewGroupDialog } from "./RemovePeerReviewGroup";
import { EditPeerReviewGroupButton, EditPeerReviewGroupDialog } from "./EditPeerReviewGroup";
import { ReviewGroupWriterModel } from "./peerReviewGroupsApiSlice";

interface Props {
	rowId: number | string;
	rowName: string;
	coursePromptGroup?: CoursePromptReviewGroup;
	availablePool?: ReviewGroupWriterModel[];
	onEditCoursePromptGroup?: (newGroup: CoursePromptReviewGroup) => void;
	onRemoveCoursePromptGroup?: (uniqueId: string) => void;
	setAlert?: (message: string, level?: AlertLevel) => void;
}

export function PeerReviewGroupRowActions(props: Props) {
	const [isEditGroupDialogOpen, setIsEditGroupDialogOpen] = useState(false);
	const [isRemoveGroupDialogOpen, setIsRemoveGroupDialogOpen] = useState(false);

	const handleEditButtonClick = () => {
		props.setAlert?.("");
		setIsEditGroupDialogOpen(true);
	};

	const handleRemoveButtonClick = () => {
		props.setAlert?.("");
		setIsRemoveGroupDialogOpen(true);
	};

	return (
		<>
			<Menu as="div" className="flex justify-end">
				<MenuButton id={`settings-button-${props.rowId}`}>
					<div className="flex items-center justify-center">
						<Cog8ToothIcon className="size-5" />
						<ChevronDownIcon className="size-4" />
					</div>
				</MenuButton>
				<Transition
					as={Fragment}
					leave="transition ease-in duration-75"
					leaveFrom="transform opacity-100 scale-100"
					leaveTo="transform opacity-0 scale-95">
					<MenuItems className="absolute z-10 mt-6 rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden">
						<MenuItem key={`edit-group-${props.rowId}`}>
							<EditPeerReviewGroupButton onClick={handleEditButtonClick} />
						</MenuItem>
						<MenuItem key={`remove-group-${props.rowId}`}>
							<RemovePeerReviewGroupButton onClick={handleRemoveButtonClick} />
						</MenuItem>
					</MenuItems>
				</Transition>
			</Menu>

			{isEditGroupDialogOpen && (
				<EditPeerReviewGroupDialog
					rowId={props.rowId}
					isDialogOpen={isEditGroupDialogOpen}
					coursePromptGroup={props.coursePromptGroup}
					availablePool={props.availablePool}
					onEditCoursePromptGroup={props.onEditCoursePromptGroup}
					onClose={() => setIsEditGroupDialogOpen(false)}
				/>
			)}

			{isRemoveGroupDialogOpen && (
				<RemovePeerReviewGroupDialog
					rowId={props.rowId}
					rowName={props.rowName}
					isDialogOpen={isRemoveGroupDialogOpen}
					onRemoveCoursePromptGroup={props.onRemoveCoursePromptGroup}
					setAlert={props.setAlert}
					onClose={() => setIsRemoveGroupDialogOpen(false)}
				/>
			)}
		</>
	);
}
